import {
  type QueryClient,
  useQuery,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { StatusCode, type BundleRating } from '@hungryroot/rest';
import {
  getApiV2CustomersSelfBundleRatingsBundleId,
  type Params,
} from '@hungryroot/rest/api/v2/customers/self/bundle_ratings/[bundle_id]/get';

type UseSelfBundleRatingProps = {
  params: Params;
  options?: Omit<UseQueryOptions<BundleRating>, 'queryFn' | 'queryKey'>;
};

export function getQueryKey({ bundle_id }: Params) {
  return ['Customer', 'Bundle Rating', { bundle_id }];
}

export function invalidateQuery({
  bundle_id,
  queryClient,
}: Pick<Params, 'bundle_id'> & { queryClient: QueryClient }) {
  queryClient.invalidateQueries({
    queryKey: getQueryKey({ bundle_id }),
  });
}

export function useSelfBundleRating(props: UseSelfBundleRatingProps) {
  const { params, options } = props;

  return useQuery({
    queryKey: getQueryKey(params),
    queryFn: async () => {
      const res = await getApiV2CustomersSelfBundleRatingsBundleId(params);

      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }

      return res.data;
    },
    ...options,
  });
}
